import switches from './switches'

export default switches
